__turbopack_context__.v({
  "className": "noto_sans_malayalam_59b6e33e-module___QX6SG__className",
});
